/* News */
export const GET_NEWS = "GET_NEWS";
export const GET_NEWS_SUCCESS = "GET_NEWS_SUCCESS";
export const GET_NEWS_FAIL = "GET_NEWS_FAIL";

///adding news
export const ADD_NEWS = "ADD_NEWS";
export const ADD_NEWS_SUCCESS = "ADD_NEWS_SUCCESS";
export const ADD_NEWS_FAIL = "ADD_NEWS_FAIL";
//updating News

export const UPDATE_NEWS = "UPDATE_NEWS";
export const UPDATE_NEWS_SUCCESS = "UPDATE_NEWS_SUCCESS";
export const UPDATE_NEWS_FAIL = "UPDATE_NEWS_FAIL";

//deleting News

export const DELETE_NEWS = "DELETE_NEWS";
export const DELETE_NEWS_SUCCESS = "DELETE_NEWS_SUCCESS";
export const DELETE_NEWS_FAIL = "DELETE_NEWS_FAIL";
///comments
export const GET_COMMENTS = "GET_COMMENTS";
export const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_COMMENTS_FAIL = "GET_COMMENTS_FAIL";

/// add comments
export const ADD_COMMENTS = "ADD_COMMENTS";
export const ADD_COMMENTS_SUCCESS = "ADD_COMMENTS_SUCCESS";
export const ADD_COMMENTS_FAIL = "ADD_COMMENTS_FAIL";

///comments
export const GET_COMMENTS_CYCLE_RENEW = "GET_COMMENTS_CYCLE_RENEW";
export const GET_COMMENTS_CYCLE_RENEW_SUCCESS =
  "GET_COMMENTS_CYCLE_RENEW_SUCCESS";
export const GET_COMMENTS_CYCLE_RENEW_FAIL = "GET_COMMENTS_CYCLE_RENEW_FAIL";

/// add comments
export const ADD_COMMENTS_CYCLE_RENEW = "ADD_COMMENTS_CYCLE_RENEW";
export const ADD_COMMENTS_CYCLE_RENEW_SUCCESS =
  "ADD_COMMENTS_CYCLE_RENEW_SUCCESS";
export const ADD_COMMENTS_CYCLE_RENEW_FAIL = "ADD_COMMENTS_CYCLE_RENEW_FAIL";
